export default {
    canBeStretched: true,
    mobileConversionConfig: {
        fixedSize: {width: 280, height: 240}
    }
}
